import { gql } from "@apollo/client";
import { betItemFragment } from "./bet-item";
import { betDetailsStakeOrders } from "./stake-order";

export const betSlipFragment = gql`
  fragment BetSlip on BetSlip {
    id
    updatedAt
    resolvedAt
    status
    refundReason
    insertedAt
    groupBetId
    betTotalAmount
    payout
    serviceFee
    user {
      id
    }
    stakeOffer {
      id
      status
      maximumMultiplier
      reward {
        id
        rewards {
          amount
          wallet
        }
      }
      orders {
        ...StakeOrder
      }
    }
    payoutAmounts {
      amount
      wallet
    }
    team {
      gameSlug
    }
    betItems {
      ...BetItem
    }
  }

  ${betItemFragment}
  ${betDetailsStakeOrders}
`
